'use strict';

require('../../style/index.css');

require('./index.css');


//////////////////
// WEBPACK FOOTER
// ./~/_antd@2.13.2@antd/lib/message/style/css.js
// module id = 604
// module chunks = 0